import React from 'react';
interface MinimizeIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function MinimizeIcon({
	width = 16,
	height = 16,
	viewBox = '0 0 16 16',
	fill = 'currentColor',
	...props
}: Readonly<MinimizeIconProps>): JSX.Element {
	return (
		<svg {...props} fill="none" width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.3 13.413V9.1a.5.5 0 01.5-.5h4.334a.5.5 0 010 1h-3.096l3.576 3.453a.5.5 0 01-.694.72L9.3 10.276v3.136a.5.5 0 01-1 0zM1.98 2.146a.5.5 0 01.707 0l3.68 3.68V2.721a.5.5 0 011 0v4.312a.5.5 0 01-.5.5H2.533a.5.5 0 010-1H5.66l-3.68-3.68a.5.5 0 010-.707z"
				fill={fill}
			/>
		</svg>
	);
}
